/**
 * Texts for Press Releases page
 */
export const pressReleasesPageText = {
    title: 'Komunikaty prasowe - CamAPS FX',
    titleMeta: 'Komunikaty prasowe - CamAPS FX',
    descriptionMeta: 'Najnowsze komunikaty prasowe i wiadomości z CamAPS FX.',
    keywords: 'camaps komunikaty prasowe, camaps wiadomości, wiadomości o technologii cukrzycy',
    localeMeta: 'pl_pl',

    bannerTitle: 'Komunikaty prasowe',
    bannerSubtitle: 'Bądź na bieżąco z naszymi najnowszymi ogłoszeniami',

    contactText: 'W przypadku pytań prasowych prosimy o kontakt przez <a href="mailto:media@camdiab.com">media@camdiab.com</a>',
    pressReleasesDisclaimer: 'Wszystkie komunikaty prasowe są publikowane w języku angielskim.',

    download: 'Pobierz',
    showMore: 'Pokaż więcej',
    showLess: 'Pokaż mniej',
};

